import Grid from '@mui/material/Grid2';
import React, { useEffect, useState } from 'react'
import "./header.css"
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../services/apiService';
// import { apiService } from '../../services/apiService';
function Header({generalData}) {
    const navigate = useNavigate();
    const [goDash,setGoDash] = useState(true);
    const [goDash2,setGoDash2] = useState(true);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(true);
    const isMdScreen = window.matchMedia('(max-width: 991px)').matches;
    const handleReloadnavigate = () => {
        window.location.reload(); // This will reload the page
        navigate("/");
    };
    const isAuthenticated = !!localStorage.getItem('token');
    useEffect(() => {
        if (!isAuthenticated) {
            setGoDash2(true);
        }else{
            setGoDash2(false);
        }
    }, [isAuthenticated]);

    useEffect(() => { 
        const fetchData = async () => {
            setLoading2(true);
            try {
                const response = await apiService.postRequest(`profile`);
                if (response.success) {
                    setGoDash(false);
                }else{
                    if(response && response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                    }
                    setGoDash(true);
                }
            }catch(error) {
                console.error('Error', error);
            }finally{
                setLoading2(false);
            }
        };
        fetchData();
    }, []);
    const fetchData = async () => {
        setLoading(true);
        try {
        const response = await apiService.postRequest(`profile`);
        if (response.success) {
            if(isMdScreen){
                navigate("/knowledge");
            }else{
                navigate("/dashboard");
            }
        }else{
            if(response && response.authenticate === false){
                await apiService.postRequest('/auth/logout');
                localStorage.clear();
                sessionStorage.clear();
                navigate('/login');
            }
        }
        }catch (error) {
            console.error('Error', error);
        }finally{
            setLoading(false);
        }
    };
  return (
    <Grid size={{xs:12}} container justifyContent="space-between" className="header_main" alignItems="center">
        <Grid size={{ xs: 4, sm: 3, md: 2, lg:1.5  }} container >
          {generalData && generalData.site_logo ? <img onClick={handleReloadnavigate} src={generalData.site_logo} alt=''/> :
            <img onClick={handleReloadnavigate} src={require('../../assets/logo.svg').default} alt=''/>
          }
        </Grid>
        <Grid size={{ xs: 8, sm: 6, md: 6, lg:6  }} container justifyContent="flex-end">
            {!loading2 && <>
            {!goDash && !goDash2 ? 
            <Button className='register_btn' onClick={() => fetchData()}>{loading ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : isMdScreen ? "Get In" : "Go To Dashboard"}</Button>:
            <>
            <Button className='login_btn' onClick={() =>{navigate("/login")}}>Login</Button>
            <Button className='register_btn' onClick={() =>{navigate("/loginselect")}}>Register Now</Button>
            </>}</>}
        </Grid>
    </Grid>
  )
}

export default Header
